import { of, combineLatest } from 'rxjs'
import Cookies from 'js-cookie'
import { filter, map, distinctUntilChanged, tap, concatMap } from 'rxjs/operators'
import { isEmpty } from 'libraries/lodash'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { Interact } from 'front-end-core/services/WindowService'
import { isValidResponse } from 'front-end-core/helpers/dataflow'
import { User } from 'services/SessionService'
import { formattedDate, findTargetElement } from 'helpers/analytics'

window.dataLayer = window.dataLayer || []

export const pushEvent = ({ category, action, label }) => window.dataLayer.push({
  event: category,
  eventCategory: category,
  eventAction: action,
  eventLabel: label,
  dateTime: formattedDate()
})

const pageView = url => window.dataLayer.push({
  event: 'pageView',
  pageView: url,
  dateTime: formattedDate()
})

const initInteraction = () => Interact.pipe(
  map(x => x.target),
  map(findTargetElement),
  filter(el => !!el),
  tap(pushEvent)
)

const mapUrl = (url) => url.replace(/^\/?secure\/?/ig, '').replace(/^\/?ms\//ig, '')

const initPages = app => app.pipe(
  map(({ url, queryString }) => Object.assign({}, { url, queryString })),
  distinctUntilChanged(({
    url: prevUrl, queryString: prevQueryString
  }, {
    url: currUrl, queryString: currQueryString
  }) => {
    return isEmpty(currQueryString)
      ? prevUrl === currUrl
      : prevUrl === currUrl && prevQueryString === currQueryString
  }),
  tap(({ url: path, queryString }) =>
    pageView(mapUrl(`${window.location.pathname}${window.location.search}`))
  )
)

const initUser = (response) => isValidResponse(response)
  ? of(response).pipe(
    tap(({ analyticsId }) => window.dataLayer.push({
      userId: analyticsId,
      clientId: Cookies.get('_ga') ? Cookies.get('_ga').slice(6) : null
    }))
  )
  : of('')

export const initTrack = app => User.pipe(
  filter(response => response !== RESPONSE_PENDING),
  concatMap(initUser),
  concatMap(() => combineLatest(initInteraction(), initPages(app)))
).subscribe()
